import React from 'react';

const CryptoCurrency = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM7.81395 3.53488C7.81395 3.22663 7.56406 2.97674 7.25581 2.97674C6.94757 2.97674 6.69767 3.22663 6.69767 3.53488V4.46512H5.02326C4.71501 4.46512 4.46512 4.71501 4.46512 5.02326C4.46512 5.33151 4.71501 5.5814 5.02326 5.5814H5.5814V10.4186H5.02326C4.71501 10.4186 4.46512 10.6685 4.46512 10.9767C4.46512 11.285 4.71501 11.5349 5.02326 11.5349H6.69767V12.4651C6.69767 12.7734 6.94757 13.0233 7.25581 13.0233C7.56406 13.0233 7.81395 12.7734 7.81395 12.4651V11.5349H8.55814V12.4651C8.55814 12.7734 8.80804 13.0233 9.11628 13.0233C9.42452 13.0233 9.67442 12.7734 9.67442 12.4651V11.5349H9.86047C10.7852 11.5349 11.5349 10.7852 11.5349 9.86047V9.11628C11.5349 8.6874 11.3737 8.29626 11.1085 8C11.3737 7.70374 11.5349 7.3126 11.5349 6.88372V6.13953C11.5349 5.21478 10.7852 4.46512 9.86047 4.46512H9.67442V3.53488C9.67442 3.22663 9.42452 2.97674 9.11628 2.97674C8.80804 2.97674 8.55814 3.22663 8.55814 3.53488V4.46512H7.81395V3.53488ZM6.69767 7.44186V5.5814H7.25514H7.25648H9.11561H9.11695H9.86047C10.1687 5.5814 10.4186 5.83129 10.4186 6.13953V6.88372C10.4186 7.19196 10.1687 7.44186 9.86047 7.44186H6.69767ZM6.69767 8.55814H9.86047C10.1687 8.55814 10.4186 8.80804 10.4186 9.11628V9.86047C10.4186 10.1687 10.1687 10.4186 9.86047 10.4186H6.69767V8.55814Z",
      fill: "black"
    }
  )
);
CryptoCurrency.displayName = "Icons.CryptoCurrency";

export { CryptoCurrency };
//# sourceMappingURL=CryptoCurrency.js.map
